

export default {
  locale: 'et',
  Pagination: {
    items_per_page: '/ leheküljel',
    jump_to: 'Hüppa',
    jump_to_confirm: 'Kinnitage',
    page: '',
    prev_page: 'Eelmine leht',
    next_page: 'Järgmine leht',
    prev_5: 'Eelmised 5 lehekülge',
    next_5: 'Järgmised 5 lehekülge',
    prev_3: 'Eelmised 3 lehekülge',
    next_3: 'Järgmised 3 lehekülge',
    page_size: 'lehe suurus'
  },
  DatePicker: {
    lang: {
      placeholder: 'Vali kuupäev',
      rangePlaceholder: ['Algus kuupäev', 'Lõpu kuupäev'],
      locale: 'et_EE',
      today: 'Täna',
      now: 'Praegu',
      backToToday: 'Tagasi tänase juurde',
      ok: 'Ok',
      clear: 'Tühista',
      month: 'Kuu',
      year: 'Aasta',
      timeSelect: 'Vali aeg',
      dateSelect: 'Vali kuupäev',
      monthSelect: 'Vali kuu',
      yearSelect: 'Vali aasta',
      decadeSelect: 'Vali dekaad',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Eelmine kuu (PageUp)',
      nextMonth: 'Järgmine kuu (PageDown)',
      previousYear: 'Eelmine aasta (Control + left)',
      nextYear: 'Järgmine aasta (Control + right)',
      previousDecade: 'Eelmine dekaad',
      nextDecade: 'Järgmine dekaad',
      previousCentury: 'Eelmine sajand',
      nextCentury: 'Järgmine sajand'
    },
    timePickerLocale: {
      placeholder: 'Vali aeg'
    }
  },
  TimePicker: {
    placeholder: 'Vali aeg'
  },
  Calendar: {
    lang: {
      placeholder: 'Vali kuupäev',
      rangePlaceholder: ['Algus kuupäev', 'Lõpu kuupäev'],
      locale: 'et_EE',
      today: 'Täna',
      now: 'Praegu',
      backToToday: 'Tagasi tänase juurde',
      ok: 'Ok',
      clear: 'Tühista',
      month: 'Kuu',
      year: 'Aasta',
      timeSelect: 'Vali aeg',
      dateSelect: 'Vali kuupäev',
      monthSelect: 'Vali kuu',
      yearSelect: 'Vali aasta',
      decadeSelect: 'Vali dekaad',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Eelmine kuu (PageUp)',
      nextMonth: 'Järgmine kuu (PageDown)',
      previousYear: 'Eelmine aasta (Control + left)',
      nextYear: 'Järgmine aasta (Control + right)',
      previousDecade: 'Eelmine dekaad',
      nextDecade: 'Järgmine dekaad',
      previousCentury: 'Eelmine sajand',
      nextCentury: 'Järgmine sajand'
    },
    timePickerLocale: {
      placeholder: 'Vali aeg'
    }
  },
  Table: {
    filterTitle: 'Filtri menüü',
    filterConfirm: 'OK',
    filterReset: 'Nulli',
    selectAll: 'Vali kõik',
    selectInvert: 'Inverteeri valik',
    filterEmptyText: 'Filtreid pole',
    filterCheckall: 'Vali kõik',
    filterSearchPlaceholder: 'Otsi filtritest',
    emptyText: 'Andmed puuduvad',
    selectNone: 'Kustuta kõik andmed',
    selectionAll: 'Vali kõik andmed',
    sortTitle: 'Sorteeri',
    expand: 'Laienda rida',
    collapse: 'Ahenda rida',
    triggerDesc: 'Klõpsa kahanevalt sortimiseks',
    triggerAsc: 'Klõpsa kasvavalt sortimiseks',
    cancelSort: 'Klõpsa sortimise tühistamiseks'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Tühista',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Tühista'
  },
  Transfer: {
    searchPlaceholder: 'Otsi siit',
    itemUnit: 'kogus',
    itemsUnit: 'kogused',
    titles: ['', ''],
    remove: 'Eemalda',
    selectCurrent: 'Vali praegune leht',
    removeCurrent: 'Eemalda praegune leht',
    selectAll: 'Vali kõik',
    removeAll: 'Eemalda kõik andmed',
    selectInvert: 'Inverteeri valik'
  },
  Upload: {
    uploading: 'Üleslaadimine...',
    removeFile: 'Eemalda fail',
    uploadError: 'Üleslaadimise tõrge',
    previewFile: 'Faili eelvaade',
    downloadFile: 'Lae fail alla'
  },
  Empty: {
    description: 'Andmed puuduvad'
  },
  global: {
    placeholder: 'Palun vali'
  },
  Icon: {
    icon: 'ikoon'
  },
  Text: {
    edit: 'Muuda',
    copy: 'Kopeeri',
    copied: 'Kopeeritud',
    expand: 'Laienda'
  },
  PageHeader: {
    back: 'Tagasi'
  },
  Image: {
    preview: 'Eelvaade'
  }
};
